module.exports = __webpack_public_path__ + "static/media/login_bg.bdb43926.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg.jpg
// module id = 1181
// module chunks = 0